"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopAreaNavigation = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _context = require("../../context");
var _navigation = require("../../context/navigation");
var _hooks = require("../../hooks");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const TopAreaNavigation = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    topAreaNavigation
  } = (0, _context.useAppConfig)();
  const visible = (0, _hooks.useIsTopAreaNavigationVisible)();
  const {
    toggleActiveMenu
  } = (0, _navigation.useActiveMenu)();
  const linkData = (0, _utils.mapLinkData)(topAreaNavigation);
  const onClick = (0, _react.useCallback)(link => {
    const {
      hash
    } = new URL(link.relativeUrl, window.location.href);
    if (Object.values(_constants.TopAreaNavigationLink).includes(hash)) {
      toggleActiveMenu(_constants.TopAreaNavigationLinkToMenuTypesMapper[hash]);
    } else if (link.relativeUrl) {
      const url = new URL(link.relativeUrl, window.location.href);
      window.location.href = url.href;
    }
  }, [toggleActiveMenu]);
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants2.TOP_AREA_NAVIGATION),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CategoryBar, {
      linkData: linkData,
      onClick: onClick
    })
  });
};
exports.TopAreaNavigation = TopAreaNavigation;
